//
//
//
//
//
//
//
//

export default {
    name: 'Full',

    data(){ return {
        showFooter: false
    }},

    methods: {

    }

}
